import axios from "axios";

export const fastenHeathApiInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});
